import React from 'react';

export const Checkmark = () => (
    <path d='M5 12l5 5l10 -10' />
);